var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$me && _vm.visible)?_c('div',{staticClass:"action-container"},[_c('a',{staticClass:"btn btn-lg",class:_vm.css,on:{"click":_vm.navigate}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.buttonTitle)}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }